import React from 'react';
import OfferNote from './OfferNote';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'offer-note';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <OfferNote
        key={`${type}-${index}`}
        note={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
